import AppProvider from './src/codes/providers/appProvider';

export const wrapRootElement = AppProvider;
